import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HeaderService {
  private showBackButtonSubject = new BehaviorSubject<boolean>(false);
  showBackButton$ = this.showBackButtonSubject.asObservable();

  private defaultHrefSubject = new BehaviorSubject<string>('/home');
  defaultHref$ = this.defaultHrefSubject.asObservable();

  setShowBackButton(show: boolean) {
    this.showBackButtonSubject.next(show);
  }

  setDefaultHref(href: string) {
    this.defaultHrefSubject.next(href);
  }
}
